module.exports = "//s3plus.meituan.net/v1/mss_65766da973d14523b3d781fe3ac2bbac/www-assets/views/layouts/components/bottom-cover/close-v4b9c9648.png";